class Fetch {
    /**
     * 
     * @param {*} url 
     * @param {*} options 
     * 
     * Fetch class helps get data from the AWS RDS database based on the url you pass in
     */
    async request(url, options) {
        const response = await fetch(url, options);
        // parse the response as JSON object
        return response.json();
    }
}

export default Fetch;


// WEBPACK FOOTER //
// ./src/common/fetch.js